module.exports = __webpack_public_path__ + "static/img/3.e79a311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/22/3.png
// module id = aWY0
// module chunks = 0